import { render, staticRenderFns } from "./AddRobot.vue?vue&type=template&id=ffd2ba0e"
import script from "./AddRobot.vue?vue&type=script&lang=js"
export * from "./AddRobot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports